import { ElementRef, Injectable } from '@angular/core';

import Map from 'ol/Map';
import Overlay from 'ol/Overlay';

import LineString from 'ol/geom/LineString.js';
import Polyline from 'ol/format/Polyline';
import { Coordinate } from '@shared/service-proxies/service-proxies';

declare var ol: any;

//import { AngularOpenlayersModule } from 'angular2-openlayers';


Injectable({
    providedIn: "root"
})

 export class SROsmsService { 

    private _turkeyLat = 41.0082;
    private _turkeyLng = 28.9784;

    private _map : any = null;
    private _vectors : any = [];

	private  _vectorSource = new ol.source.Vector({});
	private  _vectorSourcePoint = new ol.source.Vector({});

    public initMap(target : string){
		
        //  this._map = new Map({
		// 	target: target,
		//   	layers: [new TileLayer({ source: new OSM() })],
		//   	view: new View({ center: fromLonLat([this._turkeyLng, this._turkeyLat]), zoom: 5 })
		// });

        this._map = new ol.Map({
			target: target,
			layers: [
				new ol.layer.Tile(
					{
						source: new ol.source.OSM()
					}
				),
				new ol.layer.Vector({
					source: this._vectorSource
				})
				
				
			],

		  	view: new ol.View({ center: ol.proj.fromLonLat([this._turkeyLng, this._turkeyLat]), zoom: 8 })
		});

    }

    public setClickEventToMap(clickEvent){

        this._map.on('singleclick', function (evt) {
			//console.log(evt.coordinate);
		
            let lonLatArray = ol.proj.toLonLat(evt);

            //Eski Hali ancak lonLatArray değeri boş gidiyor
            // clickEvent(lonLatArray);

            clickEvent(ol.proj.transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326'));
			//// convert coordinate to EPSG-4326
			//console.log(ol.proj.transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326'));
		});
    }

    public MarkerOperation = new class {

        constructor(public osmSuper: SROsmsService) {
        }

		public addMarker(lat, lng, draggableEvent = null, maxZoom = null, icon = null){
			

            var styleMarker = new ol.style.Style({
                image: new ol.style.Icon({
                  scale: 1, 
                  anchor: [0.5, 1],
				  src: icon ? icon : '../../../../../assets/media/icons/marker/marker.png'
				}),
				//text: new ol.style.Text({
				//	text: "99",
				//	offsetY: -22,
				//	//scale: 1.0,
				//	fill: new ol.style.Fill({
				//		color: "#fff"
				//	}),
				//	stroke: new ol.style.Stroke({
				//		color: "0",
				//		width: 3
				//	})
				//})

            });


			
            var marker = new ol.geom.Point(ol.proj.transform([lng, lat], 'EPSG:4326', 'EPSG:3857'));
		    var featureMarker = new ol.Feature(marker);
			
			//let popup = new ol.Popup.FramedCloud("chicken",
			//	marker.lonlat,
			//	new ol.Size(200, 200),
			//	"example popup",
			//	null, true);
			
            var vector = new ol.layer.Vector({
                source: new ol.source.Vector({
                    features: [featureMarker]
                }),
                style: [styleMarker]
            });
			

            this.osmSuper._vectors.push(vector);

			if (!maxZoom) {

				//anlık zoom değerini dinamic olarak alır.
				maxZoom = this.osmSuper._map.getView().getZoom();
			}

			const fitOptions = { maxZoom: maxZoom, duration: 1000 }

			this.osmSuper._map.getView().fit(featureMarker.getGeometry(), fitOptions)

			this.osmSuper._map.addLayer(vector);



            if(draggableEvent != null){

                var translate1 = new ol.interaction.Translate({
                    features: new ol.Collection([featureMarker])
                });
                
                this.osmSuper._map.addInteraction(translate1);
    
                translate1.on('translateend', function (evt) {
    
                    let coordinatesArray = ol.proj.toLonLat(marker.getCoordinates());
        
                    draggableEvent(coordinatesArray);
                });
            }


			
        }

        deleteAll(){

            this.osmSuper._vectors.forEach(vector => {
                
                this.osmSuper._map.removeLayer(vector);

            });
		}

    }(this); 


	 public polyLineOperation = new class {

		 constructor(public osmSuper: SROsmsService) {

		 }


		 public draw(sPoints: Coordinate[]) {
			 
			 var points = [];

			 sPoints.forEach(shape => {
				 

				 points.push(ol.proj.transform([shape.longitude, shape.latitude], 'EPSG:4326', 'EPSG:3857'));

			 });



			 var thing = new ol.geom.MultiLineString([points]);
			 var featurething = new ol.Feature({
				 name: "Thing",
				 geometry: thing,
				
			 });

			 var styles = [
				 // linestring
				 new ol.style.Style({
					 stroke: new ol.style.Stroke({
						 color: 'blue',
						 width: 4
					 })
				 })
			 ];
			 

			 featurething.setStyle(styles);
			 this.osmSuper._vectorSource.addFeature(featurething);
			
		 }

		

	 }(this); 

}
